import(/* webpackMode: "eager" */ "/app/apps/tiny-url/src/app/global-error.tsx");
